import { render, staticRenderFns } from "./LernzielvereinbarungBewertungModal.vue?vue&type=template&id=5256aa6c"
import script from "./LernzielvereinbarungBewertungModal.vue?vue&type=script&lang=js"
export * from "./LernzielvereinbarungBewertungModal.vue?vue&type=script&lang=js"
import style0 from "./LernzielvereinbarungBewertungModal.vue?vue&type=style&index=0&id=5256aa6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports